module.exports = __webpack_public_path__ + "img/member_text.e8c129c1.svg";